import { ProjectType } from "../../../../../../platform/modules/project/project-type.enum";
import { PageEntryItem } from "./page-entry-item.model";
import { RiskPageData } from "./risk-page-data.model";

export class AuditPageEntries {
  readonly auditPackageItemId?: number;
  readonly auditPackageId?: number;
  readonly projectId: number;
  readonly chaseId: number;
  readonly numeratorId: number;
  readonly pageEntries?: PageEntryItem[];
  readonly pages?: any;
  readonly pageData?: string;
  readonly isDataEntryPrinting?: boolean;
  readonly dataEntryPrintingUrl?: string;
  readonly entityId?: number;
  readonly userRank?: number;
  readonly riskPageData?: RiskPageData;
  readonly projectType: ProjectType;
  readonly memberId?: number;

  constructor(options: {
    auditPackageItemId?: number;
    auditPackageId?: number;
    projectId: number;
    chaseId: number;
    numeratorId: number;
    pageEntries?: PageEntryItem[];
    pages?: any;
    pageData?: string;
    isDataEntryPrinting?: boolean;
    dataEntryPrintingUrl?: string;
    entityId?: number;
    userRank?: number;
    riskPageData?: RiskPageData;
    projectType?: ProjectType;
    memberId?: number;
  }) {
    this.auditPackageItemId = options.auditPackageItemId;
    this.auditPackageId = options.auditPackageId;
    this.projectId = options.projectId;
    this.chaseId = options.chaseId;
    this.numeratorId = options.numeratorId;
    this.pageEntries = options.pageEntries;
    this.pages = options.pages;
    this.pageData = options.pageData;
    this.isDataEntryPrinting = options.isDataEntryPrinting;
    this.dataEntryPrintingUrl = options.dataEntryPrintingUrl;
    this.entityId = options.entityId;
    this.userRank = options.userRank;
    this.riskPageData = options.riskPageData;
    this.projectType = options.projectType || ProjectType.HEDIS;
    this.memberId = options.memberId;
  }

  toApiRequest(): any {
    return {
      AuditPackageItemId: this.auditPackageItemId,
      AuditPackageId: this.auditPackageId,
      ProjectId: this.projectId,
      ChaseId: this.chaseId,
      NumeratorId: this.numeratorId,
      PageEntries: this.pageEntries,
      Pages: this.pages,
      PageData: this.pageData,
      IsDataEntryPrinting: this.isDataEntryPrinting,
      DataEntryPrintingUrl: this.dataEntryPrintingUrl,
      EntityId: this.entityId,
      UserRank: this.userRank,
      RiskPageData: this.riskPageData,
      ProjectType: this.projectType,
      MemberId: this.memberId,
    };
  }
}
